import { alertAnatomy } from '@chakra-ui/anatomy';
import { AlertStatus, createMultiStyleConfigHelpers } from '@chakra-ui/react';
const { definePartsStyle } = createMultiStyleConfigHelpers(alertAnatomy.keys);

const containerBG: Record<AlertStatus, string> = {
  error: 'white',
  info: 'white',
  loading: 'white',
  success: 'white',
  warning: 'white',
};

const containerBorderColor: Record<AlertStatus, string> = {
  error: 'red.500',
  info: 'blue.300',
  loading: 'blue.500',
  success: 'green.500',
  warning: '#f7b902',
};

const titleColor: Record<AlertStatus, string> = {
  error: 'red.500',
  info: 'blue.300',
  loading: 'blue.500',
  success: 'green.500',
  warning: '#f7b902',
};

const descriptionColor: Record<AlertStatus, string> = {
  error: 'red.200',
  info: 'blue.300',
  loading: 'blue.500',
  success: 'green.500',
  warning: '#f7b902',
};

const iconColor: Record<AlertStatus, string> = {
  error: 'red.300',
  info: 'blue.300',
  loading: 'blue.500',
  success: 'green.500',
  warning: '#f7b902',
};

export default {
  baseStyle: definePartsStyle((props) => {
    const { status } = props;

    return {
      container: {
        bg: containerBG[status as AlertStatus],
        borderColor: containerBorderColor[status as AlertStatus],
        borderRadius: 'md',
        borderStyle: 'solid',
        borderWidth: '1px',
        button: {
          color: iconColor[status as AlertStatus],
        },
        color: titleColor[status as AlertStatus],
      },
      description: {
        color: descriptionColor[status as AlertStatus],
        fontSize: '14px',
        lineHeight: 1,
      },
      icon: {
        alignSelf: 'flex-start',
        color: iconColor[status as AlertStatus], // change the icon color
      },
      spinner: {
        color: iconColor[status as AlertStatus], // change the icon color
      },
      title: {
        color: titleColor[status as AlertStatus],
        fontSize: '14px',
        lineHeight: '20px',
      },
    };
  }),
  variants: {
    'left-accent': (props: any) => {
      const { status } = props;
      return {
        container: {
          borderInlineStartColor: iconColor[status as AlertStatus],
        },
      };
    },
  },
};
